/// <reference types="vite/client" />
import { MiniKitProvider } from '@coinbase/onchainkit/minikit'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { WagmiProvider } from 'wagmi'
import { base } from 'wagmi/chains'

import { miniappRouter } from './MiniappRouter'
import { queryClient } from '@/config/query-client'
import { getConfig } from '@/config/wagmi'
import { useViteErrorOverlay } from '@/domain/errors/useViteErrorOverlay'
import { useAutoSwitchToInjectedChain } from '@/domain/hooks/useAutoSwitchToInjectedChain'
import { useAutoConnect } from '@/domain/wallet/useAutoConnect'
import { TooltipProvider } from '@/ui/atoms/tooltip/Tooltip'

const config = getConfig()

function MiniappApp() {
  if (import.meta.env.VITE_PLAYWRIGHT === '1') {
    // biome-ignore lint/correctness/useHookAtTopLevel: <missing explanation>
    useAutoConnect({ config })
  }
  if (import.meta.env.MODE === 'development') {
    // biome-ignore lint/correctness/useHookAtTopLevel: <missing explanation>
    useViteErrorOverlay()
  }

  if (import.meta.env.VITE_FEATURE_RPC_INJECTION_VIA_URL === '1') {
    // biome-ignore lint/correctness/useHookAtTopLevel: <missing explanation>
    useAutoSwitchToInjectedChain({ config })
  }

  return (
    <MiniKitProvider chain={base}>
      <WagmiProvider config={config}>
        <QueryClientProvider client={queryClient}>
          <TooltipProvider delayDuration={0}>
            <RouterProvider router={miniappRouter} />
          </TooltipProvider>
        </QueryClientProvider>
      </WagmiProvider>
    </MiniKitProvider>
  )
}

export default MiniappApp
